// Wallet/trustline readiness — read-only
// GET /api/wallets/crypto/offering-readiness-checks?offeringId=...
// Returns the investor's latest wallet status + the offering's trustline
// status. Backed by the crypto-wallet controller.
export const WALLET_ENDPOINTS = {
  OFFERING_READINESS: '/api/wallets/crypto/offering-readiness-checks',
} as const
